<template>
  <div class="page flex-col">
    <div class="top-bar flex-row">
      <img class="logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.png" />
      <span class="nav-link" @click="showContact = true">联系我们</span>
    </div>
    <div class="banner flex-col"><span class="banner-title">基于AI的建筑业数字化建造互联网平台</span></div>

    <div class="main-area flex-row">
      <div class="sidebar flex-col">
        <div class="nav-item" @click="$router.push('/lanhu_quanguochengshuzihua')">全过程数字化管控</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhengxiangshejijieduan')">正向设计阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_heidengshengchanjieduan')">黑灯生产阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_wurenshigong')">无人/少人施工阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhihuiyunwei')">智慧运维阶段</div>
        <div class="nav-item active" @click="$router.push('/lanhu_qita')">其他AI智能体</div>
        <div class="nav-item" @click="showContact = true">定制开发模块</div>
      </div>

      <!-- 10个智能体按钮：左列1-5，右列6-10 -->
      <div class="ai-columns flex-row">
        <div class="ai-column flex-col">
          <div class="ai-card flex-row" v-for="(item, index) in aiList.slice(0,5)" :key="index" @click="handleAiClick(item)">
            <img class="ai-icon" referrerpolicy="no-referrer" :src="item.icon" />
            <span class="ai-name" v-html="item.name"></span>
          </div>
        </div>
        <div class="ai-column flex-col">
          <div class="ai-card flex-row" v-for="(item, index) in aiList.slice(5,10)" :key="index+5" @click="showContact = true">
            <img class="ai-icon" referrerpolicy="no-referrer" :src="item.icon" />
            <span class="ai-name" v-html="item.name"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer flex-row">
      <img class="footer-logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.png" />
      <span class="footer-text">赢技科技发展（杭州）有限公司&nbsp;<br/>联系我们：yingji&#64;yjyunjz.com<br/>版权所有&nbsp;浙ICP备1214545号-1</span>
    </div>

    <div class="contact-modal-ask" v-if="showContact" @click.self="showContact = false">
      <div class="contact-modal">
        <div class="contact-modal-header"><span class="contact-modal-title">联系我们</span><span class="contact-modal-close" @click="showContact=false">✕</span></div>
        <div class="contact-modal-body">
          <div class="contact-item"><span class="contact-label">公司名称：</span><span class="contact-value">赢技科技发展（杭州）有限公司</span></div>
          <div class="contact-item"><span class="contact-label">联系邮箱：</span><a class="contact-value contact-link" href="mailto:yingji@yjyunjz.com">yingji@yjyunjz.com</a></div>
          <div class="contact-item"><span class="contact-label">官方网站：</span><span class="contact-value">www.yjyunjz.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showContact: false,
      aiList: [
        { name: '建筑投标智能体', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1', link: 'http://121.41.12.240:4173/' },
        { name: '智能体2', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体3', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体4', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体5', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体6', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体7', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体8', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体9', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' },
        { name: '智能体10', icon: 'https://lanhu-oss-proxy.lanhuapp.com/SketchPngd81a677e34da1db6f09ede00de6db425a93c7b9d35f90e23c8dfdb34c054afe1' }
      ]
    };
  },
  methods: {
    handleAiClick(item) {
      if (item.link) {
        window.open(item.link, '_blank');
      } else {
        this.showContact = true;
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.nav-link{cursor:pointer}.nav-link:hover{opacity:.75}
.ai-card{cursor:pointer;transition:opacity .2s,transform .15s}
.ai-card:hover{opacity:.85;transform:scale(1.03)}
.contact-modal-ask{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999}
.contact-modal{background:#fff;border-radius:12px;padding:32px 40px;min-width:380px;box-shadow:0 16px 48px rgba(0,0,0,.2)}
.contact-modal-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}
.contact-modal-title{font-size:20px;font-weight:700;color:#1a1a2e}
.contact-modal-close{cursor:pointer;font-size:18px;color:#999;padding:4px}.contact-modal-close:hover{color:#333}
.contact-modal-body{display:flex;flex-direction:column;gap:16px}
.contact-item{display:flex;align-items:flex-start;font-size:15px;line-height:1.6}
.contact-label{color:#666;white-space:nowrap;min-width:90px}
.contact-value{color:#1a1a2e;font-weight:500}
.contact-link{color:#2563eb;text-decoration:none}.contact-link:hover{text-decoration:underline}
</style>
